import { render, staticRenderFns } from "./LegendIcon.vue?vue&type=template&id=4baf9774&scoped=true&"
import script from "./LegendIcon.vue?vue&type=script&lang=js&"
export * from "./LegendIcon.vue?vue&type=script&lang=js&"
import style0 from "./LegendIcon.vue?vue&type=style&index=0&id=4baf9774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf9774",
  null
  
)

export default component.exports